import { type TFunction } from "i18next"
import { url as urlHelper } from "@/common/locales"

export const Routemap = {
  customerZone(t: TFunction): string {
    return urlHelper(t("route.customer_zone"))
  },

  customerZoneNew(t: TFunction): string {
    return urlHelper(`${t("route.customer_zone")}/new`)
  },

  customerZoneLogin(t: TFunction): string {
    return urlHelper(`${t("route.customer_zone")}/login`)
  },

  customerZoneLogout(t: TFunction): string {
    return urlHelper(`${t("route.customer_zone")}/logout`)
  },

  customerZoneProfile(t: TFunction): string {
    return urlHelper(`${t("route.customer_zone")}/profile`)
  },

  customerZoneChangePassword(t: TFunction): string {
    return urlHelper(`${t("route.customer_zone")}/change_password`)
  },
}
